import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { BathroomConfigurationService } from 'src/app/services/configurators-2d/mobile/bathroom/bathroom-configuration.service';
import { CustomerService } from 'src/app/services/customer.service';
import { DatasService } from 'src/app/services/datas.service';
import { StatisticService } from 'src/app/services/statistic.service';
import { StatisticTypeEnum } from 'src/app/enum/statistic-type.enum';
import { TunnelDataStore } from 'src/app/stores/tunnel/tunnel-data.store';

@Component({
  selector: 'ng-casto-bathroom-configurator-choice',
  templateUrl: './bathroom-configurator-choice.component.html',
  styleUrls: ['./bathroom-configurator-choice.component.scss'],
})
export class BathroomConfiguratorChoiceComponent implements OnInit {
  private readonly customer = inject(CustomerService);
  private readonly router = inject(Router);
  private readonly statisticService = inject(StatisticService);
  private readonly tunnelDataStore = inject(TunnelDataStore);
  private readonly bathroomConfigurationService = inject(BathroomConfigurationService);
  protected readonly datas = inject(DatasService);
  private readonly LOCAL_STORAGE_LAST_CONTEXT_TOKEN = 'last-context';

  ngOnInit(): void {
    if (this.hasBothChoices) {
      return;
    }

    if (this.datas.bathroomEnabled) {
      this.start3d();
      return;
    }

    if (this.datas.bathroomV2Enabled) {
      this.start2d();
    }
  }

  protected get hasBothChoices(): boolean {
    return this.datas.bathroomEnabled && this.datas.bathroomV2Enabled;
  }

  protected start3d(): void {
    if (!this.datas.bathroomEnabled) return;

    this.updateContext(CONFIG_CONTEXT.BATHROOM);
    this.tunnelDataStore.resetState(false);
    // Le parcours SDB 3D entre par le tunnel (étape « Conception » = iframe ByMe),
    // afin d'exposer l'étape « Pose » calculée par SPID à partir de la BOM.
    this.router.navigate(['/tunnel']);
  }

  protected start2d(): void {
    if (!this.datas.bathroomV2Enabled) return;

    this.updateContext(CONFIG_CONTEXT.BATHROOM_V2);
    this.tunnelDataStore.resetState(false);
    this.bathroomConfigurationService.resetAll();
    void this.statisticService.sendStatistic(
      StatisticTypeEnum.BATHROOM_STARTED_FROM_DESKTOP_COUNT,
      1,
      CONFIG_CONTEXT.BATHROOM_V2
    );
    this.router.navigate(['/tunnel']);
  }

  private updateContext(context: CONFIG_CONTEXT): void {
    this.customer.context = context;
    localStorage.setItem(this.LOCAL_STORAGE_LAST_CONTEXT_TOKEN, context);
  }
}
